import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export default function VersionSelect({ label, versions, value, onChange }) {
  return (
    <FormControl fullWidth size="small" disabled={versions.length === 0}>
      <InputLabel>{label}</InputLabel>
      <Select label={label} value={value} onChange={(event) => onChange(event.target.value)}>
        {versions.map((version) => (
          <MenuItem key={version} value={version}>
            {version}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
